module.exports = __webpack_public_path__ + "static/67872057_2337675113227631_7962588381433561088_n-c581ff144ce3c2b65c99d5374d37d0b4.jpg";